import Vue from 'vue'

/**
 * @author jorge nuñez lópez <>
 *
 * Release Extra Output requests
 * @param outputsRequest Output requests object
 * @return {object}
 */

export default (extraOutputsRequest) => {
  return Vue.$http.post(`/iwarehouse/output_extra/approve/`, extraOutputsRequest)
}


// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/releaseExtraMaterial.js